import { render, staticRenderFns } from "./RegisterSummary.vue?vue&type=template&id=c86f271c&"
import script from "./RegisterSummary.vue?vue&type=script&lang=js&"
export * from "./RegisterSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports